import { render, staticRenderFns } from "./priceEmphasis.vue?vue&type=template&id=362c4e45&scoped=true&lang=pug"
import script from "./priceEmphasis.vue?vue&type=script&lang=js"
export * from "./priceEmphasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c4e45",
  null
  
)

export default component.exports